import { createBrowserRouter, RouterProvider } from 'react-router';
import { useGAPageTracking, useRoutesInit } from '@vivli/core/infrastructure/hook';
import { useEffect, useState } from 'react';
export const AppRoutesWrapper = () => {
    const routes = useRoutesInit();
    const [router, setRouter] = useState<any>();

    useGAPageTracking();

    useEffect(() => {
        if (!routes || router) {
            return;
        }

        setRouter(createBrowserRouter(routes));
    }, [routes]);

    return router && <RouterProvider router={router} />;
};
